import React, {useEffect, useState} from 'react';

const COLOURS = ['#00acd1', '#FF6D02', '#F5BE1E', '#D99BD9', '#4CAF50', '#4286F4', '#494fa2'];
const PIECES = 60;
const DURATION = 2600;

export default function ({trigger}) {
    const [pieces, setPieces] = useState([]);

    useEffect(() => {
        if (!trigger) {
            return;
        }
        setPieces(Array.from({length: PIECES}, (value, index) => ({
            id: `${trigger}-${index}`,
            left: Math.random() * 100,
            colour: COLOURS[index % COLOURS.length],
            delay: Math.random() * 400,
            drift: (Math.random() - 0.5) * 240,
            spin: (Math.random() - 0.5) * 1080,
            round: Math.random() > 0.6
        })));
        const timeout = setTimeout(() => setPieces([]), DURATION + 500);

        return () => clearTimeout(timeout);
    }, [trigger]);

    return (
        <div className='student-intro-confetti' aria-hidden='true'>
            {pieces.map(piece => (
                <span
                    key={piece.id}
                    className={'student-intro-confetti-piece' + (piece.round ? ' round' : '')}
                    style={{
                        left: `${piece.left}%`,
                        backgroundColor: piece.colour,
                        animationDelay: `${piece.delay}ms`,
                        animationDuration: `${DURATION}ms`,
                        '--drift': `${piece.drift}px`,
                        '--spin': `${piece.spin}deg`
                    }}
                />
            ))}
        </div>
    );
}
